//getters.js
import Util from "@/config/util"
import { isNumeric } from "vant/lib/utils";

export const getters = {
  account: (state) => {
    const address = state.address;

    // 使用 toFixed(8) 保留6位小数，然后用 parseFloat() 去掉多余的零
    const total_income = parseFloat(state.users?.leiji || 0)
      + parseFloat(state.users?.tiqu || 0)
      + parseFloat(state.users?.freeze || 0)

    // @FIXME state.balance是前端获取到的余额
    const balance = isNumeric(state.users?.balance) ? Util.tools.floatFormat(state.users.balance) : 0
    const balance_ext = isNumeric(state.users?.balance_ext) ? Util.tools.floatFormat(state.users.balance_ext) : 0 //赠送余额
    const balance_all = balance + balance_ext + total_income;

    // 质押提现的统计
    const withdraw_summary = state.users?._withdraw_data || {withdraw_cnt:0, withdraw_sum:0};
 
    return {
      balance: balance + balance_ext > 0 ? Util.tools.floatFormat(balance + balance_ext) : '-',// 钱包余额
      balance_all: balance_all > 0 ? Util.tools.floatFormat(balance_all) : '-', // 钱包余额（UI2专用）
      vip_level: state.users?.vip_level || 0, // VIP等级
      pledge_level: state.users?.pledge_level || 0, // 质押等级
      pledge_enable: state.users?.pledge_enable || 0, // 质押资格：关闭=0，开启=1
      total_income: Util.tools.floatFormat(total_income), // 总收益
      total_interest: Util.tools.floatFormat(state.users?.leiji), // 累计提息(已提取成功)
      interest_balance: Util.tools.floatFormat(state.users?.tiqu), // 利息余额(未提取的-可以提取的最大值)
      interest_frozen: Util.tools.floatFormat(state.users?.freeze), // 利息冻结(提取中的)
      pledge_amount: Util.tools.floatFormat(state.users?.pledge_amount) || '-', // 质押金额
      daily_interest: Util.tools.floatFormat(state.users?.daily_interest), // 日利息（预期）
      address: address,
      address_masked: Util.tools.maskAddress(address),
      auto_interest: Util.tools.floatFormat(state.users?.auto_interest), // 余额派息:0关闭，1开启
      pledge_interest: Util.tools.floatFormat(state.users?.pledge_interest), // 质押派息:0关闭，1开启
      withdraw_summary: withdraw_summary, // 质押提现的统计
    };
  },
  expected: (state) => {
    return {
      pledge_income: Util.tools.floatFormat(state.expected?.pledge_income, 4), // 质押收益
      liquid_income: Util.tools.floatFormat(state.expected?.liquid_income, 4), // 流动性收益
    };
  },
  address: (state) => {
    return state.address;
  },
  chain: (state) => {
    return state.chain;
  },
};